import { render, staticRenderFns } from "./CustomerProfile.htm?vue&type=template&id=07a44a2e&scoped=true&"
import script from "./CustomerProfile.ts?vue&type=script&lang=js&"
export * from "./CustomerProfile.ts?vue&type=script&lang=js&"
import style0 from "./CustomerProfile.scss?vue&type=style&index=0&id=07a44a2e&lang=scss&scoped=true&"
import style1 from "./CustomerProfileSection.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a44a2e",
  null
  
)

export default component.exports